import { Music2, Sparkles, Users, Target, Video, RefreshCw } from "lucide-react";
import AdsPlatformPage from "../components/site/AdsPlatformPage";
import { usePageSEO, breadcrumb, serviceSchema, faqSchema } from "../hooks/usePageSEO";

const config = {
  meta: { eyebrow: "TikTok Ads" },
  hero: {
    title: "Adquisición moderna,",
    highlight: "creatividad que vende",
  },
  intro: {
    eyebrow: "Performance creativo",
    title: "TikTok no premia el dinero — premia la creatividad ejecutada con criterio.",
    body:
      "Implemento campañas de TikTok Ads con un foco quirúrgico: pipeline creativo constante, audiencias bien construidas y conexión real con tu sistema de adquisición. No content random, sistema.",
  },
  services: [
    { icon: Music2, title: "TikTok Ads · Performance", desc: "Conversiones, Lead Generation, tráfico y catálogo con tracking serio." },
    { icon: Video, title: "Estrategia creativa", desc: "Hooks, formatos UGC, voiceovers y guiones diseñados para retener." },
    { icon: Users, title: "Audiencias inteligentes", desc: "Lookalikes, intereses, comportamientos y custom audiences avanzadas." },
    { icon: Target, title: "Pixel + Events API", desc: "Tracking server-side y eventos personalizados para optimización real." },
    { icon: Sparkles, title: "Spark Ads & Creators", desc: "Amplificación de orgánico y colaboración con creadores con criterio." },
    { icon: RefreshCw, title: "Iteración creativa", desc: "Pipeline semanal de variantes para vencer la fatiga típica de TikTok." },
  ],
  approach: [
    "TikTok Pixel + Events API antes de escalar — sin tracking, no escalo.",
    "Pipeline creativo de 8-15 variantes por mes para mantener performance fresco.",
    "Audiencias construidas, no improvisadas: tests por hipótesis y eliminación.",
    "Spark Ads cuando tu marca o un creador ya validó orgánicamente.",
    "Conexión directa a IA conversacional para responder en segundos.",
    "Reportes con CAC, ROAS, hook rate, hold rate y CTR diferenciado.",
  ],
  whyItems: [
    { title: "Criterio creativo, no caos", desc: "TikTok funciona con creatividad — pero solo si cada pieza tiene una hipótesis." },
    { title: "Operación, no estrategia bonita", desc: "Yo coordino guiones, voces, edición, tests y optimización. Todo conectado." },
    { title: "Sistema de adquisición real", desc: "Cada lead conecta con WhatsApp, IG o tu CRM — no a un excel olvidado." },
  ],
  faqs: [
    { q: "¿TikTok Ads sirve para B2B?", a: "Sí, en categorías específicas (educación corporativa, software accesible, fintech). No es la primera plataforma para enterprise puro pero cabe en mid-market." },
    { q: "¿Cuánto cuesta producir creatividades?", a: "Trabajo con UGC, creators y producción in-house según presupuesto. Te propongo el setup más eficiente para tu caso." },
    { q: "¿Funciona si no hago contenido orgánico?", a: "Funciona, pero rinde mucho mejor cuando hay un canal orgánico activo que sirva de base creativa y permita Spark Ads." },
  ],
  related: [
    { to: "/meta-ads", label: "Meta Ads", desc: "Combina TikTok con Meta para escalar audiencias jóvenes con remarketing." },
    { to: "/automatizacion-ia", label: "Automatización con IA", desc: "Cada lead que llega entra a un flujo de IA conversacional." },
    { to: "/funnels", label: "Funnels", desc: "Sistema completo conectado a TikTok." },
  ],
  resultStat: {
    value: "+40%",
    label: "incremento potencial en conversión cuando el funnel está bien implementado",
    footnote: "Resultado típico de implementaciones bien ejecutadas.",
  },
};

export default function TikTokAdsPage() {
  usePageSEO({
    title: "TikTok Ads para Empresas | Daos Ads",
    description:
      "TikTok Ads con criterio creativo: audiencias inteligentes, Pixel + Events API, Spark Ads y pipeline creativo iterado. Adquisición moderna conectada a IA conversacional.",
    path: "/tiktok-ads",
    jsonLd: [
      breadcrumb([
        { name: "Inicio", path: "/" },
        { name: "TikTok Ads", path: "/tiktok-ads" },
      ]),
      serviceSchema({
        name: "TikTok Ads performance",
        description:
          "Campañas de TikTok Ads con audiencias inteligentes, Events API server-side, Spark Ads y pipeline creativo sistematizado.",
        path: "/tiktok-ads",
      }),
      faqSchema(config.faqs),
    ],
  });
  return <AdsPlatformPage {...config} />;
}
